import { createSelector } from '@reduxjs/toolkit';
import { selectUserAccount } from 'user/api';

import { answersAdapter } from './answers.slice';

import type { RootState } from 'store';

const answersSelectors = answersAdapter.getSelectors<RootState>((state) => state.question.answers);

const selectQuestionsRoot = (state: RootState) => state.question;

export const selectQuestionTitle = createSelector(selectQuestionsRoot, (state) => state.questionAssignment?.title);
export const selectQuestionActiveAnswerId = (state: RootState) => state.question.questionAssignment.activeAnswerId;
export const selectAnswers = (state: RootState) => answersSelectors.selectAll(state);
export const selectAnswersIds = (state: RootState) => answersSelectors.selectIds(state);
export const selectAnswer = answersSelectors.selectById;

export const selectAnswerAssignedToUserIds = createSelector(selectAnswer, (answer) => answer?.assignedToUserIds);

export const selectAnswerText = createSelector(selectAnswer, (answer) => answer?.text);

export const selectAnswerCanEdit = createSelector(
  (state: RootState, answerId?: string) => (answerId ? selectAnswer(state, answerId) : undefined),
  selectUserAccount,
  (answer, user) => !!user?.id && !!answer?.assignedToUserIds.includes(user.id)
);
